export default function setState ({ props, state }) {
  state.set(props.stateVar, props.stateVal)
};
